export default {
 data() {
  return {
   errorStatus: "",
   errorStatusText: "",
   errorDataResponse: "",
   errorDetails: [], // Add a new property to store error details
  };
 },
 methods: {
  errorHandling(err) {
   console.error(err);
   // Reset error details
   this.errorDetails = [];

   if (err.response && err.response.status == 401) {
    if (this.$route.path.includes("dashboard")) {
     this.$router.push("/tickets");
    } else {
     localStorage.removeItem("token");
     localStorage.removeItem("adminToken");
     this.$store.dispatch("token", null);
     this.$store.dispatch("adminToken", null);
     this.$router.push("/login");
    }
   } else if (err.response && err.response.status == 403) {
    if (this.$route.path.includes("dashboard")) {
     this.$router.push("/tickets");
    } else {
     this.errorStatus = err.response.status;
     this.errorStatusText = err.response.statusText;
     this.$router.push("/");
    }
   } else if (err.response && (err.response.status == 500 || !err.response)) {
    this.errorStatus = err.response.status;
    this.errorStatusText = err.response.statusText;
    this.$router.push("/server-error");
   } else if (localStorage.getItem("account") === "ADMIN") {
    if (this.$route.name !== "Impersonate") {
     this.$router.push("/impersonate").then(() => location.reload());
    }
   } else {
    this.errorStatus = err.response.status;
    this.errorStatusText = err.response.statusText;

    // Handle different error response formats
    if (err.response.data.response) {
     this.errorDataResponse = err.response.data.response;
    } else if (err.response.data.message) {
     this.errorDataResponse = err.response.data.message;

     // Handle the new error format with errors array
     if (err.response.data.errors) {
      // Process errors array
      if (Array.isArray(err.response.data.errors)) {
       err.response.data.errors.forEach(error => {
        if (Array.isArray(error)) {
         // Handle nested arrays of errors
         error.forEach(detail => {
          this.errorDetails.push(detail);
         });
        } else {
         // Handle direct error strings
         this.errorDetails.push(error);
        }
       });
      }
     }
    }
   }
  },
 },
};
